import { HelpVideoChildComponent } from '../helpVideoChildComponent';

const GettingSetup = () => {
  const topicList = [
    { id: '840824035', label: 'How to add Email to your Wisestep Account' },
    { id: '836088379', label: 'How to download Wisestep extension from chrome' },
  ];
  return <HelpVideoChildComponent isFromSettings={true} topicArrayList={topicList} />;
};

export default GettingSetup;
